module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', {
    staticClass: "mt-2 mb-2"
  }, [_vm._v("Client data")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.caseModel.client ? _vm.caseModel.client.name : 'N/A') + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Client Agreement And Invoice")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-tab') && _vm.caseInvoices && _vm.caseInvoices.length) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": 'green',
      "block": "",
      "loading": _vm.loading.paidInvoiceBtn,
      "disabled": _vm.markPaidDisabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.markPaid($event)
      }
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Mark Invoice Paid")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Agreement")])]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingAgreement,
      "disabled": !_vm.caseModel.answers.length,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadAgreement
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Latest " + _vm._s((_vm.caseModel.status === 'closed') ? 'Invoice' : 'Quotation') + "\n          "), (_vm.caseInvoices.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.caseInvoices[_vm.caseInvoices.length - 1].status) + ")")]) : _vm._e()])]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingInvoice,
      "disabled": _vm.disabled.invoice,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadInvoice
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Final Receipt")])]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "mr-2"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingReceiptEmail,
      "disabled": _vm.disabled.receipt,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.sendReceipt
    }
  }, [_vm._v("SEND\n          "), _c('v-icon', [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingReceiptDownload,
      "disabled": _vm.disabled.receipt,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadReceipt
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "no-data-text": "No invoices."
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "flat": "",
            "depressed": "",
            "small": "",
            "left": "",
            "href": props.item.invoice_path,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s((_vm.caseModel.status === 'closed') && (props.item.id === _vm.items[_vm.items.length - 1].id) ? 'view invoice' : 'view quotation'))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status ? props.item.status : 'pending'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.$can('mark-paid', 'invoices') && props.item.status === 'pending') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.markPaidInvoice(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v("\n          Mark paid\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage,
      "rawHtml": ""
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6879c85d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseClientDataTable.vue
// module id = 1002
// module chunks = 1